'use client'

import { useCookieValue } from '@react-hookz/web/useCookieValue/index.js'
import { Button } from '@snowball-tech/fractal/dist/src/components/Button'
import { Typography } from '@snowball-tech/fractal/dist/src/components/Typography'

import { LOCAL_DOMAIN, PREPROD_DOMAIN, SNOWBALL_DOMAIN } from '../constants'
import { isDev, isPreview } from '../helpers'
import useTranslations from '../hooks/useTranslations'

export default function CookiesLink() {
  const $t = useTranslations()

  const [, , removeConsent] = useCookieValue('gdpr-consent', {
    domain: isDev()
      ? LOCAL_DOMAIN
      : isPreview()
        ? PREPROD_DOMAIN
        : SNOWBALL_DOMAIN,
    expires: Math.round(365 / 2),
    sameSite: 'lax',
  })

  const resetConsent = () => {
    removeConsent()
  }

  return (
    <Button variant="text" onClick={resetConsent}>
      <Typography className="text-grey-50" element="p" variant="caption-link">
        {$t('footer.cookies')}
      </Typography>
    </Button>
  )
}
